// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__lqIYA","file":"styles_file__pDFL8"};